var map = {
	"./Chat.svg": 746,
	"./addCardIcon.svg": 493,
	"./anect-logo.svg": 325,
	"./card/text-box.svg": 494,
	"./card/triangle.svg": 747,
	"./cardBack.png": 748,
	"./check.svg": 749,
	"./clashing-edu-logo-currentColor-orange.svg": 750,
	"./clashing-edu-logo-vertical-currentColor-orange.svg": 751,
	"./clashing-logo-currentColor.svg": 752,
	"./clashing-logo-without-text.svg": 753,
	"./clashing-logo.png": 495,
	"./employee-CardBack.png": 496,
	"./employee.png": 212,
	"./employee2.png": 326,
	"./employee3.png": 327,
	"./employeeDeck.png": 497,
	"./employeeEdu.png": 328,
	"./employeeEdu2.png": 319,
	"./hacker-CardBack.png": 498,
	"./hacker-secred-card.png": 499,
	"./hacker.png": 213,
	"./hacker2.png": 329,
	"./hacker3.png": 330,
	"./hackerDeck.png": 500,
	"./hackerEdu.png": 331,
	"./hackerEdu2.png": 320,
	"./hidden-card-icon.svg": 754,
	"./home.svg": 755,
	"./icons/exit.svg": 756,
	"./icons/tournament.svg": 757,
	"./icons/training.svg": 758,
	"./icons/unfinishedGame.svg": 759,
	"./idea.svg": 501,
	"./info.svg": 760,
	"./lock.svg": 324,
	"./notificationOFF.svg": 761,
	"./notificationON.svg": 762,
	"./notificationSound.mp3": 445,
	"./notifications.svg": 763,
	"./page-loading.png": 764,
	"./page-loading1.gif": 765,
	"./page-loading2.gif": 766,
	"./pointing-hand.svg": 502,
	"./secretTargetEndGame.png": 503,
	"./security-manager-left.png": 504,
	"./security-manager-lower-right-with-ending.png": 767,
	"./security-manager-lower-right.png": 505,
	"./security-manager-right-with-ending.png": 768,
	"./security-manager-right.png": 506,
	"./security-manager-up.png": 507,
	"./security-manager.png": 769,
	"./turn-off.svg": 770,
	"./white-logo.svg": 508,
	"./zamec.png": 771
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 745;